/**
 * This component holds the whole app ui routing system, lazy loads private routes
 */
import React, { Suspense, lazy, useEffect } from "react";
import { Route, Switch, BrowserRouter, HashRouter } from "react-router-dom";
import ErrorThrower from "./ErrorThrower";
import fetchRoute from "utils/routes";
import GenericWrapper from "assets/js/components/GenericWrapper";
import OnboardingFlow from "assets/js/scenes/OnBoardingFlow/OnBoardingFlow";
import PublicHash from "assets/js/scenes/publicHash/PublicHash";
import { setLocalLocize } from "utils/languages";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import store from "./store";
import { initPostHog } from "assets/js/const/SegmentEvents";
import OAuthCodeLogin from "assets/js/scenes/authFlow/containers/OAuthCodeLogin";
import LoggedOut from "assets/js/scenes/authFlow/containers/LoggedOut";
import { addToImpersonificationTree, amIImpersonating, removeImpersonificationTree } from "./utils/apiUtils";
import { useState } from "react";
import { getUrlQueryParam, removeLegacyParameterByName } from "./utils/urlUtils";

const UI = lazy(() => import("assets/js/UI"));

function UIMain() {
	const [currentKey, setCurrentKey] = useState(amIImpersonating(true));
	useEffect(() => {
		const impersonateAccount = getUrlQueryParam("impersonate");

		if (impersonateAccount) {
			removeImpersonificationTree();
			addToImpersonificationTree(impersonateAccount);
			removeLegacyParameterByName("impersonate");
		}

		if (window.location.hash.includes(fetchRoute("public"))) {
			setLocalLocize();
		}
		if (!window.location.href.includes("#" + fetchRoute("listRedirections"))) {
			initPostHog(store.getState().brand?.client_config?.segment_config);
		}
	}, []);

	function refreshApp() {
		setCurrentKey(amIImpersonating(true));
	}

	return (
		<PostHogProvider client={posthog}>
			<BrowserRouter>
				<GenericWrapper>
					<ErrorThrower>
						<Suspense fallback={<></>}>
							<Switch key={currentKey}>
								<Route
									path={fetchRoute("public")}
									render={(props) => (
										<OnboardingFlow
											authenticated={false}
											fetchAccount={() => { }}
											{...props}
										/>
									)}
								/>
								<Route
									path={fetchRoute("oauthCodeCallback")}
									render={() => <OAuthCodeLogin />}
								/>
								<Route
									path={fetchRoute("loggedOut")}
									render={() => <LoggedOut />}
								/>
								{!window.location.hash.includes(fetchRoute("public")) && <UI refreshApp={refreshApp} />}
								<HashRouter>
									<Switch>
										<Route
											path={fetchRoute("public")}
											render={() => <PublicHash />}
										/>
									</Switch>
								</HashRouter>
							</Switch>
						</Suspense>
					</ErrorThrower>
				</GenericWrapper>
			</BrowserRouter>
		</PostHogProvider>
	);
}
export default UIMain;
